export default [
    {
        value: "ContratacaoDeAuditoriaContabilEFinanceira",
        text: "Contratação de auditoria contábil e financeira"
    },
    {
        value: "Outros",
        text: "Outros"
    }
]